import { useMemo } from 'react';
/**
 * スライドに関する情報の取得
 */
export const useSlideSearchSlideSlides = (options) => {
    const { id, ids, rawSlides, viewParams } = options;
    const { defaultImageIndexMap, defaultSlideIndex, mainSlide, notLoadedListIds, slides, } = useMemo(() => {
        const dataList = ids
            .map((v) => rawSlides[v])
            .filter((v) => v)
            .map((v) => v.value)
            .filter((v) => v);
        const slideIndex = dataList.findIndex((v) => v.id === id);
        const indexMap = {};
        dataList.forEach((v, i) => {
            const value = viewParams.find((p) => p.slideId === v.id) || {};
            const { pageId } = value;
            const pageIndex = v.pages.findIndex((p) => p.id === pageId);
            indexMap[i] = pageIndex < 0 ? 0 : pageIndex;
        });
        return {
            defaultImageIndexMap: indexMap,
            defaultSlideIndex: slideIndex < 0 ? 0 : slideIndex,
            mainSlide: dataList.find((v) => v && v.id === id),
            notLoadedListIds: ids.filter((v) => rawSlides[v] === undefined),
            slides: dataList,
        };
    }, [id, ids, viewParams, rawSlides]);
    return {
        defaultImageIndexMap,
        defaultSlideIndex,
        mainSlide,
        notLoadedListIds,
        slides,
    };
};
export default useSlideSearchSlideSlides;
